import React from "react";

const Spinner = () => (
  <div className="spinner">
    <div className="spinner__wrapper"></div>
  </div>
);

export default Spinner;